import { snakeCase, camelCaseToSnakeCase } from './caseConversion';

interface CamelCaseObject {
  [key: string]: string | boolean | null | number | undefined;
}

const mapCamelCaseObjectToSnakeCase = <Result>(
  object: CamelCaseObject,
): Result => {
  const mappedObject = {};

  Object.keys(object).forEach((key) => {
    const snakeCaseKey = camelCaseToSnakeCase(key);
    if (!snakeCase.test(snakeCaseKey)) {
      throw new Error(
        `Event Property ${key} needs to be camelCase or snake_case`,
      );
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    mappedObject[snakeCaseKey] = object[key];
  });

  return mappedObject as Result;
};

export default mapCamelCaseObjectToSnakeCase;
